import i18next from 'i18next'
import { DecimalScale, formatNumber } from '@globaleris/ui.library'

export const formatLocaleNumber = (
  value: number | undefined,
  fixedPositions: DecimalScale
): string => {
  if (value === undefined) return ''

  return formatNumber(value, i18next.language, fixedPositions)
}

export const formatLocalePercentage = (value: number | undefined | null): string => {
  if (value === undefined || value === null) return ''

  return formatLocaleNumber(calculatePercentage(value), DecimalScale.DEFAULT)
}

export const calculatePercentage = (value: number): number => {
  return +(value * 100)
}

export const formatStringNumber = (value: string): number => {
  const formattedNumber = value.replaceAll('.', '').replace(',', '.')
  return Number(formattedNumber)
}

export function isNumeric(num) {
  return !isNaN(num)
}

export const capKpiValue = (value: number | undefined, max: number): number | string => {
  if (!value) return value ?? 0
  if (value > max) return `> ${max.toLocaleString()}`
  return value
}
